<template functional>
    <div class="stepper" :class="data.staticClass">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Stepper'
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/mixins';

.stepper {
    border: 1px solid var(--border-color);
    counter-reset: step;

    ::v-deep .intro-header {
        font-size: 17px;
        font-weight: bold;
    }

    ::v-deep .step {
        border-color: var(--border-color);

        .section-header {
            font-size: 16px;
            font-weight: 500;
            display: flex;
            align-items: center;
        }

        .section-subheader {
            font-size: 16px;
        }

        .step-number {
            border: 1px solid var(--stepper-step-num-color);
            background-color: var(--stepper-step-num-bg);
            color: var(--stepper-step-num-color);
            border-radius: 50%;
            font-size: 18px;
            font-weight: 700;
            line-height: 40px;
            height: 40px;
            width: 40px;
            display: inline-block;
            text-align: center;
            margin-right: variables.$grid-padding;

            &::before {
                counter-increment: step;
                content: counter(step);
            }
        }
    }

    ::v-deep section.details-section {
        background-color: var(--stepper-step-bg);
        padding-left: variables.$grid-padding;
        padding-right: variables.$grid-padding;

        &:last-of-type {
            border-bottom: none;
        }
    }

    @include mixins.mobile-only {
        margin-left: -(variables.$grid-padding);
        margin-right: -(variables.$grid-padding);
    }
}
</style>
